/* Odisen: elegir conector y cable, agregar al carrito y revisar, de forma opcional, que le sirva al carro. */
(function () {
  'use strict';

  function num(v) {
    var n = parseFloat(String(v || '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function fmt(n) {
    return String(Math.round(n * 10) / 10).replace('.', ',');
  }

  function fill(str, vars) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] !== undefined ? vars[k] : m;
    });
  }

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function all(node, sel) {
    return Array.prototype.slice.call(node.querySelectorAll(sel));
  }

  function checkedValue(inputs) {
    for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i].value;
    return '';
  }

  function init(root) {
    if (root.__odInit) return;
    root.__odInit = true;
    var cfg, rows;
    try {
      cfg = JSON.parse(root.querySelector('[data-od-cfg]').textContent);
      rows = JSON.parse(root.querySelector('[data-od-cars]').textContent);
    } catch (e) {
      return;
    }

    var cars = rows.map(function (r) {
      return { brand: r[0], model: r[1], connector: r[2], kw1: num(r[3]), kw3: num(r[4]), note: r[5] || '' };
    });

    var waBase = root.getAttribute('data-wa-base') || '';
    var brandSel = root.querySelector('[data-od-brand]');
    var carSel = root.querySelector('[data-od-car]');
    var carNameEl = root.querySelector('[data-od-car-name]');
    var carResult = root.querySelector('[data-od-car-result]');

    var chargers = all(root, '[data-od-charger]').map(function (card) {
      var variants = [];
      var vs = card.querySelector('[data-od-variants]');
      if (vs) {
        try {
          variants = JSON.parse(vs.textContent);
        } catch (e) {
          variants = [];
        }
      }
      return {
        card: card,
        model: card.getAttribute('data-model'),
        kw: num(card.getAttribute('data-kw')) || 0,
        guns: parseInt(card.getAttribute('data-guns'), 10) || 1,
        variants: variants,
        variant: null,
        connInputs: all(card, '[data-od-conn]'),
        cableInputs: all(card, '[data-od-cable]'),
        priceEl: card.querySelector('[data-od-price]'),
        noteEl: card.querySelector('[data-od-note]'),
        addBtn: card.querySelector('[data-od-add]'),
        addText: card.querySelector('[data-od-add-text]'),
        waBtn: card.querySelector('[data-od-wa]'),
        statusEl: card.querySelector('[data-od-status]'),
        verdictEl: card.querySelector('[data-od-verdict]'),
        badgeEl: card.querySelector('[data-od-badge]')
      };
    });

    if (!chargers.length) return;

    var car = null;
    root.setAttribute('data-js', '');

    // Marcas únicas en el orden de la lista
    if (brandSel && carSel) {
      var brands = [];
      cars.forEach(function (c) {
        if (brands.indexOf(c.brand) === -1) brands.push(c.brand);
      });
      brands.forEach(function (b) {
        var o = document.createElement('option');
        o.value = b;
        o.textContent = b;
        brandSel.appendChild(o);
      });
    }

    function carName(c) {
      var last = norm(c.brand.split(' ').pop());
      return norm(c.model).indexOf(last) === 0 ? c.model : c.brand + ' ' + c.model;
    }

    function fillModels() {
      var b = brandSel.value;
      while (carSel.options.length > 1) carSel.remove(1);
      cars.forEach(function (c, idx) {
        if (c.brand !== b) return;
        var o = document.createElement('option');
        o.value = String(idx);
        o.textContent = c.model;
        carSel.appendChild(o);
      });
      carSel.disabled = !b;
      carSel.value = '';
    }

    // La combinación solo existe cuando ya se eligió conector y cable
    function isComplete(c) {
      return (!c.connInputs.length || !!checkedValue(c.connInputs)) && (!c.cableInputs.length || !!checkedValue(c.cableInputs));
    }

    function minPrice(c) {
      var best = null;
      c.variants.forEach(function (v) {
        if (v.cents > 0 && (!best || v.cents < best.cents)) best = v;
      });
      return best ? best.price : '';
    }

    function findVariant(c) {
      if (!c.variants.length || !isComplete(c)) return null;
      var need = [checkedValue(c.connInputs), checkedValue(c.cableInputs)]
        .filter(Boolean)
        .map(norm);
      for (var i = 0; i < c.variants.length; i++) {
        var have = (c.variants[i].options || []).map(norm);
        var ok = need.every(function (n) {
          return have.indexOf(n) !== -1;
        });
        if (ok) return c.variants[i];
      }
      return null;
    }

    function setStatus(c, text, kind) {
      if (!c.statusEl) return;
      c.statusEl.className = 'ev-od-card__status' + (kind ? ' is-' + kind : '');
      c.statusEl.textContent = '';
      if (text) c.statusEl.appendChild(document.createTextNode(text));
    }

    // Precio, botón de carrito y enlace de WhatsApp según lo que se eligió
    function refresh(c) {
      var conn = checkedValue(c.connInputs);
      var cable = checkedValue(c.cableInputs);
      var v = findVariant(c);
      c.variant = v;
      var priced = !!(v && v.cents > 0);
      var pending = c.variants.length > 0 && !isComplete(c);
      var fromPrice = pending ? minPrice(c) : '';
      c.card.classList.toggle('is-selected', !!(conn || cable));

      if (c.priceEl) {
        var shown = priced ? v.price : fromPrice ? 'Desde ' + fromPrice : '';
        c.priceEl.hidden = !shown;
        if (shown) {
          var prevPrice = c.priceEl.textContent;
          c.priceEl.textContent = shown;
          if (prevPrice && prevPrice !== shown) {
            c.priceEl.classList.remove('is-bump');
            void c.priceEl.offsetWidth;
            c.priceEl.classList.add('is-bump');
          }
        }
      }
      if (c.noteEl) {
        c.noteEl.hidden = priced || !!fromPrice;
        if (!priced && !fromPrice) {
          var missing = c.variants.length && !v;
          c.noteEl.textContent = missing && cfg.combo_text ? cfg.combo_text : c.noteEl.getAttribute('data-default') || '';
        }
      }
      if (c.addBtn) {
        c.addBtn.hidden = !priced;
        if (priced) {
          var sold = !v.available;
          c.addBtn.disabled = sold;
          if (c.addText) c.addText.textContent = sold ? cfg.soldout_label : cfg.add_label;
        }
      }
      if (pending) {
        setStatus(
          c,
          !conn && !cable ? 'Elige el conector y el largo del cable para ver el precio.' : !conn ? 'Elige el conector.' : 'Elige el largo del cable.',
          'hint'
        );
      } else {
        setStatus(c, '', '');
      }

      if (c.waBtn) {
        var text = cfg.wa_message + ' ' + c.model + ' (' + fmt(c.kw * c.guns) + ' kW).';
        if (conn || cable) text += ' ' + fill(cfg.wa_options, { conn: conn, cable: cable });
        if (car) text += ' ' + fill(cfg.wa_car, { car: carName(car) });
        c.waBtn.href = waBase + '?text=' + encodeURIComponent(text);
      }
    }

    function setVerdict(el, kind, title, lines) {
      el.className = 'ev-od-verdict ev-od-card__verdict' + (kind ? ' ev-od-verdict--' + kind : '');
      el.innerHTML = '';
      if (!title) return;
      var icon = document.createElement('span');
      icon.className = 'ev-od-verdict__icon';
      icon.setAttribute('aria-hidden', 'true');
      var body = document.createElement('div');
      body.className = 'ev-od-verdict__body';
      var h = document.createElement('p');
      h.className = 'ev-od-verdict__title';
      h.textContent = title;
      body.appendChild(h);
      lines.forEach(function (t) {
        if (!t) return;
        var p = document.createElement('p');
        p.className = 'ev-od-verdict__text';
        p.textContent = t;
        body.appendChild(p);
      });
      el.appendChild(icon);
      el.appendChild(body);
    }

    // El cargador más chico que aproveche todo lo que el carro acepta
    function recommend(max) {
      var sorted = chargers.slice().sort(function (a, b) {
        return a.kw - b.kw || a.guns - b.guns;
      });
      for (var i = 0; i < sorted.length; i++) {
        if (sorted[i].kw >= max - 0.6) return sorted[i];
      }
      return sorted[sorted.length - 1];
    }

    function supports(c, connector) {
      return c.connInputs.some(function (i) {
        return norm(i.value) === norm(connector);
      });
    }

    function renderVerdict(c) {
      if (!c.verdictEl) return;
      if (!car) {
        setVerdict(c.verdictEl, '', '', []);
        return;
      }
      var name = carName(car);
      var conn = checkedValue(c.connInputs);
      var conns = c.connInputs.map(function (i) { return i.value; }).join(' o ');
      var vars = { car: name, model: c.model, conn: conn, conns: conns, carconn: car.connector, kw: fmt(c.kw) };
      var noteLine = car.note ? cfg.note_label + ' ' + car.note : '';

      if (!car.connector) {
        setVerdict(c.verdictEl, 'unknown', fill(cfg.none_title, vars), [fill(cfg.none_text, vars)]);
        return;
      }
      if (norm(car.connector) !== norm(conn)) {
        var text = supports(c, car.connector) ? cfg.conn_text : cfg.connx_text;
        setVerdict(c.verdictEl, 'warn', fill(cfg.conn_title, vars), [fill(text, vars), noteLine]);
        return;
      }

      var max = car.kw3 || car.kw1;
      var extra = [];
      if (c.kw > 7.4) extra.push(fill(cfg.phase_text, vars));
      if (c.guns === 2) extra.push(fill(cfg.duo_text, vars));

      if (!max) {
        setVerdict(c.verdictEl, 'ok', fill(cfg.ok_title, vars), [fill(cfg.unk_text, vars)].concat(extra));
        return;
      }
      vars.max = fmt(max);
      var tol = 0.6;
      if (c.kw > max + tol) {
        setVerdict(c.verdictEl, 'info', fill(cfg.over_title, vars), [fill(cfg.over_text, vars)].concat(extra));
      } else if (c.kw < max - tol) {
        setVerdict(c.verdictEl, 'ok', fill(cfg.slow_title, vars), [fill(cfg.slow_text, vars)].concat(extra));
      } else {
        vars.kw = fmt(Math.min(c.kw, max));
        setVerdict(c.verdictEl, 'ok', fill(cfg.ok_title, vars), [fill(cfg.ok_text, vars)].concat(extra));
      }
    }

    function scrollToCard(c) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      c.card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }

    function renderCar() {
      var rec = null;
      chargers.forEach(function (c) {
        c.card.classList.remove('is-recommended');
        if (c.badgeEl) c.badgeEl.hidden = true;
      });
      if (carNameEl) carNameEl.textContent = car ? carName(car) : '';
      if (!carResult) return;
      carResult.innerHTML = '';
      if (!car) return;

      var name = carName(car);
      var max = car.kw3 || car.kw1;
      if (car.connector && max) rec = recommend(max);

      if (rec) {
        rec.card.classList.add('is-recommended');
        if (rec.badgeEl) {
          rec.badgeEl.textContent = fill(cfg.rec_badge, { car: name });
          rec.badgeEl.hidden = false;
        }
        var p = document.createElement('p');
        p.className = 'ev-od-car__line ev-od-car__line--rec';
        p.appendChild(document.createTextNode(fill(cfg.rec_text, { car: name, model: rec.model, conn: car.connector }) + ' '));
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ev-od-verdict__rec';
        b.textContent = cfg.rec_btn;
        b.addEventListener('click', function () {
          scrollToCard(rec);
        });
        p.appendChild(b);
        carResult.appendChild(p);
      }
      if (car.note) {
        var n = document.createElement('p');
        n.className = 'ev-od-car__line';
        n.textContent = cfg.note_label + ' ' + car.note;
        carResult.appendChild(n);
      }
    }

    function renderAll() {
      chargers.forEach(function (c) {
        refresh(c);
        renderVerdict(c);
      });
      renderCar();
    }

    function addToCart(c) {
      var v = c.variant;
      var btn = c.addBtn;
      if (!v || !v.available || !btn || btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');
      setStatus(c, '', '');

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (resp) {
          if (resp && resp.status) {
            setStatus(c, resp.description || resp.message || cfg.add_error, 'error');
            return;
          }
          try {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ev-odisen', productVariantId: v.id, cartData: resp });
            }
          } catch (e) {}
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(resp);
            setStatus(c, cfg.added_label, 'ok');
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function () {
          setStatus(c, cfg.add_error, 'error');
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-disabled');
        });
    }

    chargers.forEach(function (c) {
      if (c.addBtn) {
        c.addBtn.addEventListener('click', function () {
          addToCart(c);
        });
      }
      c.card.addEventListener('change', function (e) {
        if (!e.target || !e.target.matches('input[type="radio"]')) return;
        refresh(c);
        renderVerdict(c);
      });
    });

    if (brandSel && carSel) {
      brandSel.addEventListener('change', function () {
        fillModels();
        car = null;
        renderAll();
      });

      carSel.addEventListener('change', function () {
        car = carSel.value === '' ? null : cars[parseInt(carSel.value, 10)];
        // Si el carro usa uno de los conectores que vendemos, lo dejamos elegido
        if (car && car.connector) {
          chargers.forEach(function (c) {
            c.connInputs.forEach(function (i) {
              if (norm(i.value) === norm(car.connector)) i.checked = true;
            });
          });
        }
        renderAll();
      });
    }

    chargers.forEach(refresh);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-od-pick-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();